import React from 'react'
import { SELECTED_VARIATIONMS, SELECTED_DEPARTUREMS,SELECTED_VARIATIONMS_DEPARTUREMS } from '../../constantTypes/checkout2/selectVariationDepartureConstantTypes';

export const VariationDepartureSelectReducer=(state={},action)=> {
   switch (action.type) {
       case SELECTED_VARIATIONMS:
           return {
...state,variationselected:action.payload
           }
           case SELECTED_DEPARTUREMS:
            return {
 ...state,departureselected:action.payload
            }
            case SELECTED_VARIATIONMS_DEPARTUREMS:
                return {
                }
       default: return state;
   }
}
